import type { PageTrackingData } from './types';

const COMPETITION_NAME = 'dream team fantasy 2026';

interface RouteDefinition {
  matches: (pathname: string) => boolean;
  pageName: string;
  section: string;
  restrictions: PageTrackingData['page_restrictions'];
  pageType?: string;
}

const routeDefinitions: RouteDefinition[] = [
  {
    matches: pathname => pathname === '/',
    pageName: 'fantasy - team entry',
    section: 'onboarding',
    restrictions: 'public',
  },
  {
    matches: pathname => pathname === '/my-team',
    pageName: 'fantasy - my team',
    section: 'my team',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/my-team/history',
    pageName: 'fantasy - transfer history',
    section: 'transfer history',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/leagues',
    pageName: 'fantasy - my leagues',
    section: 'leagues',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/leagues/join',
    pageName: 'fantasy - join league',
    section: 'leagues',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/leagues/create',
    pageName: 'fantasy - create league',
    section: 'leagues',
    restrictions: 'restricted',
  },
  {
    matches: pathname => /^\/leagues\/join\/[^/]+$/.test(pathname),
    pageName: 'fantasy - join league by link',
    section: 'leagues',
    restrictions: 'public',
  },
  {
    matches: pathname => /^\/leagues\/[^/]+$/.test(pathname),
    pageName: 'fantasy - league detail',
    section: 'leagues',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/leaderboard',
    pageName: 'fantasy - leaderboard',
    section: 'leaderboard',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/match-centre',
    pageName: 'fantasy - match centre',
    section: 'match centre',
    restrictions: 'restricted',
  },
  {
    matches: pathname => /^\/match\/[^/]+$/.test(pathname),
    pageName: 'fantasy - match',
    section: 'match centre',
    restrictions: 'restricted',
  },
  {
    matches: pathname => pathname === '/stats-centre',
    pageName: 'fantasy - stats centre',
    section: 'stats centre',
    restrictions: 'restricted',
  },
  {
    matches: pathname => /^\/player\/[^/]+$/.test(pathname),
    pageName: 'fantasy - player profile',
    section: 'player profile',
    restrictions: 'public',
  },
  {
    matches: pathname => pathname === '/how-to-play',
    pageName: 'fantasy - how to play',
    section: 'how to play',
    restrictions: 'public',
  },
];

const getTemplateName = (): PageTrackingData['template_name'] => {
  if (window.matchMedia('(max-width: 767px)').matches) return 'mobile';
  if (window.matchMedia('(max-width: 1023px)').matches) return 'tablet';
  return 'desktop';
};

const normalizePathname = (pathname: string) =>
  pathname === '/' ? pathname : pathname.replace(/\/+$/, '');

export const isTeamBootstrapRoute = (pathname: string) => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    normalizedPathname === '/' ||
    normalizedPathname === '/my-team' ||
    normalizedPathname === '/my-team/history'
  );
};

export const getPageTrackingData = (pathname: string): PageTrackingData => {
  const normalizedPathname = normalizePathname(pathname);
  const route = routeDefinitions.find(candidate => candidate.matches(normalizedPathname));

  return {
    page_site_name: 'dream team web',
    page_name: route?.pageName ?? 'fantasy - page not found',
    page_section: 'gaming',
    page_section_2: 'fantasy',
    page_section_3: route?.section ?? 'not found',
    page_type: route?.pageType ?? 'game',
    template_name: getTemplateName(),
    page_restrictions: route?.restrictions ?? 'public',
    competition_name: COMPETITION_NAME,
  };
};
